import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ChevronDown, Weight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

function Blog1D() {
  const [loading, setLoading] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [formType, setFormType] = useState(""); // stores which button opened the form
const [contactForm, setContactForm] = useState({
  fullname: "",
  company: "",
  website: "",
  email: "",
  phone: "",
  message: "",
});
const handleContactChange = (e) => {
  const { name, value } = e.target;
  setContactForm((prev) => ({ ...prev, [name]: value }));
};


const isBusinessEmail = (email) => {
  const freeDomains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "aol.com",
    "icloud.com",
    "mail.com",
    "live.com"
  ];
  const domain = email.split("@")[1]?.toLowerCase();
  if (!domain) return false;
  return !freeDomains.includes(domain);
};


const handleContactSubmit = async (e) => {
  e.preventDefault();
 
  setLoading(true); // show loading message
  const { fullname, company, website, email, phone, message} = contactForm;


  // Basic validation
  if (!fullname || !email || !message || !company || !phone ) {
    alert("Please fill all required fields.");
      setLoading(false); // show loading message

    return;
  }
if (!isBusinessEmail(email)) {
    alert("Please enter a business email, not Gmail/Yahoo/etc.");
      setLoading(false); // show loading message

    return;
  }
 

  try {
     try {
    const emailCheckResponse = await fetch(
      `https://pinakinedgemedia.com/api/validateEmail?email=${email}`
    );
    const emailCheckData = await emailCheckResponse.json();

    if (!emailCheckData.exists) {
      setLoading(false);
      alert("❌ The entered email does not exist. Please use a valid business email.");
      return;
    }
  } catch (err) {
    setLoading(false);
    console.error("Email check failed:", err);
    alert("⚠️ Could not verify email existence. Try again later.");
    return;
  }
    const response = await fetch("https://pinakinedgemedia.com/api/sendContactMail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
  ...contactForm,
  formType, // ✅ add formType manually here
}),

    });

    if (response.ok) {
       setShowSuccessModal(true);  // ✅ This triggers modal to open
       setLoading(false); // show loading message
       setContactForm({
        fullname: "",
        company: "",
        website: "",
        email: "",
        phone: "",
        message: "",
      });
    } else {
      alert("Error sending message.");
    }
  } catch (err) {
    console.error(err);
    alert("Error sending message.");
  }
};
  
  return (
    <div>
      <Header />
      <main>
         <AnimatePresence>
        {showSuccessModal && (
          <motion.div
            className="modal-overlay show"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <motion.div
              className="modal show"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
              style={{
                background: "#fff",
                padding: "30px",
                borderRadius: "10px",
                width: "400px",
                textAlign: "center",
                boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
              }}
            >
              <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
                Message Sent!
              </h2>
              <p>Thank you for contacting us. We will get back to you shortly.</p>
              <button className="vc rg lk gh ml il hi gi _l"
                onClick={() => setShowSuccessModal(false)}
               
              >
                Close
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      
        {/* 🔹 FAQ Section */}
        <section className="i ji ii db">
        
      <div className="bb ze ki xn 2xl:ud-px-0">
        <div className="tc sf yo zf kq">
          <div className="ro1">
            <div className="animate_top rounded-md shadow-solid-13 bg-white dark:bg-blacksection border border-stroke dark:border-strokedark p-7.5 md:p-10">
            
            <div className="container">
               <div className="left">
          <img src="../images/blogim1.png" className="vd" alt="Blog" />
        </div>
          <div className="right">
<h2 className="ek vj 2xl:ud-text-title-lg kk wm nb gb mk">
               Review, Execute, and Convert ABM Campaigns to Sales Leads
              </h2>
                <ul className="tc uf cg 2xl:ud-gap-15 fb">
                <li>
                  <span className="rc kk wm">Published On: </span> Oct 27, 2025
                   
                </li>
                <li>
                   <span className="rc kk wm">Published by:</span> Pinakinedge Media
                </li>
              </ul>
          </div>
            </div>
            <br/>

              <p className="jutfy">
                In today’s competitive B2B marketing landscape, Account-Based Marketing (ABM) has become more than just a trend — it's a strategic necessity. Unlike broad marketing tactics, ABM focuses on high-value target accounts, offering a personalized approach that aligns marketing and sales to drive meaningful results. But running a successful ABM campaign isn’t just about selecting a few target companies and sending emails. It requires a well-defined strategy, precise execution, and ongoing review to ensure you're not only reaching the right people — but also converting them into qualified sales leads.
              </p>
               <p className="mb bgimh">
              1. Review: Start With Strategy and Data
              </p>

                <p className="jutfy">
               Before launching or optimizing any ABM campaign, it's critical to evaluate your foundation. This includes everything from your target account list to your messaging and martech stack.
              </p>
              <p className="mb bgimh">
                A.	Identify Your Ideal Customer Profiles (ICPs)
              </p>
 <p className="jutfy">
    Start by clearly defining your Ideal Customer Profiles. Who are your high-value clients? What industry, company size, geography, or tech stack do they align with? Understanding your ICP helps you zero in on the accounts most likely to convert.
              </p>
               <p className="mb bgimh">
                B.	Build a Target Account List
              </p>
 <p className="jutfy">
    Once your ICP is defined, build a target account list using tools like LinkedIn Sales Navigator, ZoomInfo, or first-party CRM data. Your list should be dynamic — reviewed and updated regularly based on real engagement and feedback from sales.
              </p>

               <p className="mb bgimh">
                C.	Review Buyer Personas and Intent Data
              </p>
 <p className="jutfy">
  Get granular by aligning your messaging to buyer personas within those accounts. Use intent data to understand where they are in the buying cycle, what topics they're researching, and what pain points they’re trying to solve. This allows you to craft more relevant content and outreach strategies.
              </p>
              <p className="mb bgimh">
               D.	Align Sales and Marketing
              </p>
 <p className="jutfy">
    ABM cannot work without sales and marketing alignment. Collaborate on messaging, workflows, KPIs, and account engagement strategies. Establish shared goals and lead qualification criteria before execution begins.
              </p>


               <p className="mb bgimh">
             2. Execute: Build a Coordinated ABM Engine
              </p>

                <p className="jutfy">
                    Execution is where strategy meets action. A successful ABM campaign blends personalized content, multi-channel outreach, and sales follow-ups — all timed and tailored to specific accounts.
              </p>
              <p className="mb bgimh">
                A. Personalize Content at Scale
              </p>
 <p className="jutfy">
    Gone are the days of generic messaging. Use dynamic content tools to create personalized landing pages, emails, ads, and videos tailored to each account or persona. The more relevant your message, the higher your engagement rate.
              </p>
                <p className="mb bgimh">
              B. Run Multi-Channel Campaigns
              </p>
 <p className="jutfy">
    Meet your prospects where they are. ABM campaigns should span across email, LinkedIn, display ads, webinars, direct mail, and outbound sales calls. Consistent messaging across channels increases brand recall and trust.
              </p>

                <p className="mb bgimh">
             C.	Use ABM Technology for Precision
              </p>
 <p className="jutfy">
    Leverage ABM platforms like Terminus, 6sense, Demandbase, or HubSpot ABM features to orchestrate, track, and measure campaigns. These tools help automate touchpoints, score engagement, and flag accounts that are showing buying signals.
              </p>

               <p className="mb bgimh">
            D. Enable the Sales Team
              </p>
 <p className="jutfy">
    Marketing’s job doesn’t end with sending leads to sales. Provide your sales team with:
              </p>
              <ul className="jutfy">
                <li>• Account-specific insights</li>
                <li>• Custom pitch decks</li>
                <li>• Talking points based on content consumed</li>
                <li>• Real-time notifications when key stakeholders engage</li>
                <li>• This ensures warm, contextual follow-ups that resonate with each account's unique situation.</li>
              </ul>

               <p className="mb bgimh">
           3. Convert: Measure, Optimize, and Drive Pipeline
              </p>

                <p className="jutfy">
                    An ABM campaign’s success is ultimately judged by its ability to drive conversions and grow revenue. Measuring the right metrics and continually refining your approach are essential.
              </p>
              <p className="mb bgimh">
                A. Track Engagement, Not Just Clicks
              </p>
 <p className="jutfy">
    Standard marketing metrics like impressions and CTRs are useful, but ABM requires a deeper look. Focus on:
              </p>
              <ul className="jutfy">
                <li>•	Account engagement score</li>
<li>•	Time spent on personalized pages</li>
<li>•	Number of stakeholders engaging</li>
<li>•	Content downloads by role</li>
<li>•	Sales meeting booked rate
</li>
              </ul>

               <p className="mb bgimh">
                B. Optimize Based on Insights
              </p>
              <p className="jutfy">
                Use the data to identify what’s working and what’s not:
              </p>
              <ul className="jutfy">
                <li>•	Which channels are driving engagement?</li>
<li>•	Which messages resonate with specific personas?</li>
<li>•	Are there any content gaps?</li>
<li>•	Is sales following up effectively?</li>
<li>•	Refine your content, outreach timing, and account list accordingly.
</li>
              </ul>
               <p className="mb bgimh">
              C. Nurture and Recycle Non-Converting Accounts
              </p>
              <p className="jutfy">
             Not every account will convert immediately — and that’s okay. ABM is a long game. Create nurture tracks for accounts that need more time or education. Recycle unresponsive accounts into future campaigns based on updated intent data.
              </p>
                 <p className="mb bgimh">
              D. Celebrate and Scale Success
              </p>
              <p className="jutfy">
                When a campaign converts, analyze the full journey:
              </p>
              <ul className="jutfy">
                <li>•	What were the key engagement moments?</li>
 <li>•	What content or touchpoint led to the breakthrough?</li>
 <li>•	How did marketing and sales collaborate?
</li>
              </ul>
               <p className="jutfy">
                Use these insights to replicate success with other accounts. Over time, your ABM program will evolve into a high-performing, revenue-generating engine.
              </p>

               <p className="mb bgimh">
           Final Thoughts: ABM Is a Continuous Cycle
              </p>
              <p className="jutfy">
               Review. Execute. Convert. Then do it again — better. That’s the nature of ABM. It’s not a one-and-done campaign but a cyclical strategy rooted in learning, adapting, and refining your approach to high-value accounts
              </p>
               <p className="mb bgimh">
           The real power of ABM lies in its focus:
              </p>
              <p className="jutfy">
                it brings clarity to your marketing efforts, strengthens alignment between sales and marketing, and delivers measurable results where it matters most — the bottom line.
                <br/>
                So, whether you're just starting out or looking to optimize your current ABM efforts, remember this: Target smart. Engage deeply. Convert efficiently. That’s how you turn intent into interest — and interest into revenue.
              </p>
                <p className="mb bgimh">
        Ready to turn your ABM strategy into a lead-generating powerhouse?
              </p>
              <p className="jutfy">Start reviewing your current process, align with sales, and get ready to convert your most valuable accounts into loyal customers.</p>
              <div className="animate_top w-full nn/5 vo/3 vk sg hh sm yh tq">
              <form onSubmit={(e) => handleContactSubmit(e)}>
  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="fullname">Full name</label>
      <input
        type="text"
        name="fullname"
        id="fullname"
        value={contactForm.fullname}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="company">Company</label>
      <input
        type="text"
        name="company"
        id="company"
        value={contactForm.company}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>

  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="website">Phone number</label>
        <input
  type="text"
  name="phone"
  id="phone"
  value={contactForm.phone}
  onChange={(e) => {
    // Allow only digits
    const value = e.target.value.replace(/\D/g, "");
    setContactForm((prev) => ({ ...prev, phone: value }));
  }}
  maxLength={10} // optional: limit to 10 digits
  className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
/>

    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="email">Email address</label>
      <input
        type="email"
        name="email"
        id="email"
        value={contactForm.email}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>
  <div className="fb">
    <label className="rc" htmlFor="message">Comment</label>
    <textarea
      placeholder="Comment"
      rows="3"
      name="message"
      id="message"
      value={contactForm.message}
      onChange={handleContactChange}
      className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 ci"
    ></textarea>
  </div>

  <div className="tc xf">
      <button
  type="submit"
  className="vc rg lk gh ml il hi gi _l"
  disabled={loading}
  onClick={() => {
    setFormType("Blog: Review, Execute, and Convert ABM Campaigns to Sales Leads");
  }}
>
  {loading ? "Please wait..." : " Post Comment"}
</button>
  </div>
</form>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
       
      </main>
      <Footer />
    </div>
  );
}

export default Blog1D;
